import { render, staticRenderFns } from "./Aneel9_RelatorioAuditoria.vue?vue&type=template&id=060ae794&"
import script from "./Aneel9_RelatorioAuditoria.vue?vue&type=script&lang=js&"
export * from "./Aneel9_RelatorioAuditoria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports